import { render, staticRenderFns } from "./dataScreening.vue?vue&type=template&id=2d200c3a&scoped=true"
import script from "./dataScreening.vue?vue&type=script&lang=js"
export * from "./dataScreening.vue?vue&type=script&lang=js"
import style0 from "./dataScreening.vue?vue&type=style&index=0&id=2d200c3a&prod&lang=scss"
import style1 from "./dataScreening.vue?vue&type=style&index=1&id=2d200c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d200c3a",
  null
  
)

export default component.exports